import { render, staticRenderFns } from "./JobListings.vue?vue&type=template&id=663f23dd&"
import script from "./JobListings.vue?vue&type=script&lang=js&"
export * from "./JobListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports